import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass(`as-goals-scored`)
}
const _hoisted_2 = { class: "as-goals-scored__head" }
const _hoisted_3 = { class: "as-history" }
const _hoisted_4 = { class: "as-history-item" }
const _hoisted_5 = { class: "as-history-item__head" }
const _hoisted_6 = { class: "as-history-item__body" }
const _hoisted_7 = {
  key: 0,
  class: "as-competition"
}
const _hoisted_8 = { class: "as-competition__table" }
const _hoisted_9 = { class: "as-center a" }
const _hoisted_10 = { class: "as-center a" }
const _hoisted_11 = {
  key: 1,
  class: "as-competition"
}
const _hoisted_12 = { class: "as-competition__table" }
const _hoisted_13 = { class: "as-center a" }
const _hoisted_14 = { class: "as-center a" }
const _hoisted_15 = { class: "as-competition__table" }
const _hoisted_16 = { class: "as-center a" }
const _hoisted_17 = { class: "as-center a" }

import IconCorner from '~src/components/icons/foot_stats/IconCorner.vue';
    import type { IMatch } from '~src/interfaces';
    import type { IFootyStats, ITeam, IStatsParent } from '~src/interfaces/footystats';
    import { ref, computed } from 'vue';
    import { getClassForItem } from '~src/helpers/footystats';

    
const __default__ = {};

interface Props{
        match: IMatch;
        mode?: string;
        footyStats: IFootyStats | null;
        homeTeamInfo: ITeam | null;
        awayTeamInfo: ITeam | null;
    }

    
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TotalCornerKicks',
  props: {
    match: {},
    mode: { default: 'as-win' },
    footyStats: {},
    homeTeamInfo: {},
    awayTeamInfo: {}
  },
  setup(__props: any) {

    const props = __props

    const activeTab = ref('all')
    const setActiveTab = (tab: string) => {
        activeTab.value = tab;
    };

    const homeTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
    });

    const awayTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
    });

    const getValueWithMode = (team = 'home', mode = 'btts', mode_half = '') => {
        const __data: IStatsParent = team === 'home' ? homeTeamLastX.value : awayTeamLastX.value;

        let __mode = mode
        if(mode_half){
            __mode = mode_half
        }
        if (!__data || !__data.stats || !__data.stats.hasOwnProperty(__mode)) {
            return 0;
        }

        return __data.stats[__mode] as number;
    }

    const calculatorAVG = (home: number, away: number) => {
        const _avg = (home + away) / 2

        return Math.round(_avg)
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(IconCorner),
      _cache[2] || (_cache[2] = _createElementVNode("span", null, " Tổng số phạt góc ", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab", { 'as-active': activeTab.value === 'all' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveTab('all')))
          }, " Cả trận ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab", { 'as-active': activeTab.value === 'half' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveTab('half')))
          }, " Hiệp 1/2 ", 2)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (activeTab.value === 'all')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("table", _hoisted_8, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[3] || (_cache[3] = _createElementVNode("th", null, "Số quả PG", -1)),
                      _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.footyStats?.home_name), 1),
                      _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.footyStats?.away_name), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("th", { class: "as-center a" }, "Trung bình", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("td", null, "Trên 6.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'over65CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'over65CornersPercentage_overall')) + "%", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'over65CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'over65CornersPercentage_overall')) + "%", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'over65CornersPercentage_overall'), getValueWithMode('away', 'over65CornersPercentage_overall')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'over65CornersPercentage_overall'), getValueWithMode('away', 'over65CornersPercentage_overall'))) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[6] || (_cache[6] = _createElementVNode("td", null, "Trên 7.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'over75CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'over75CornersPercentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'over75CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'over75CornersPercentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'over75CornersPercentage_overall'), getValueWithMode('away', 'over75CornersPercentage_overall')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'over75CornersPercentage_overall'), getValueWithMode('away', 'over75CornersPercentage_overall'))) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("td", null, "Trên 8.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'over85CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'over85CornersPercentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'over85CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'over85CornersPercentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'over85CornersPercentage_overall'), getValueWithMode('away', 'over85CornersPercentage_overall')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'over85CornersPercentage_overall'), getValueWithMode('away', 'over85CornersPercentage_overall'))) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[8] || (_cache[8] = _createElementVNode("td", null, "Trên 9.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'over95CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'over95CornersPercentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'over95CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'over95CornersPercentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'over95CornersPercentage_overall'), getValueWithMode('away', 'over95CornersPercentage_overall')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'over95CornersPercentage_overall'), getValueWithMode('away', 'over95CornersPercentage_overall'))) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("td", null, "Trên 10.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'over105CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'over105CornersPercentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'over105CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'over105CornersPercentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'over105CornersPercentage_overall'), getValueWithMode('away', 'over105CornersPercentage_overall')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'over105CornersPercentage_overall'), getValueWithMode('away', 'over105CornersPercentage_overall'))) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[10] || (_cache[10] = _createElementVNode("td", null, "Trên 11.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'over115CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'over115CornersPercentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'over115CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'over115CornersPercentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'over115CornersPercentage_overall'), getValueWithMode('away', 'over115CornersPercentage_overall')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'over115CornersPercentage_overall'), getValueWithMode('away', 'over115CornersPercentage_overall'))) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[11] || (_cache[11] = _createElementVNode("td", null, "Trên 12.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'over125CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'over125CornersPercentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'over125CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'over125CornersPercentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'over125CornersPercentage_overall'), getValueWithMode('away', 'over125CornersPercentage_overall')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'over125CornersPercentage_overall'), getValueWithMode('away', 'over125CornersPercentage_overall'))) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[12] || (_cache[12] = _createElementVNode("td", null, "Trên 13.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'over135CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'over135CornersPercentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'over135CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'over135CornersPercentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'over135CornersPercentage_overall'), getValueWithMode('away', 'over135CornersPercentage_overall')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'over135CornersPercentage_overall'), getValueWithMode('away', 'over135CornersPercentage_overall'))) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[13] || (_cache[13] = _createElementVNode("td", null, "Trên 14.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'over145CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'over145CornersPercentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'over145CornersPercentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'over145CornersPercentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'over145CornersPercentage_overall'), getValueWithMode('away', 'over145CornersPercentage_overall')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'over145CornersPercentage_overall'), getValueWithMode('away', 'over145CornersPercentage_overall'))) + "% ", 3)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (activeTab.value === 'half')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("table", _hoisted_12, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[14] || (_cache[14] = _createElementVNode("th", null, "First Half", -1)),
                      _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.footyStats?.home_name), 1),
                      _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.footyStats?.away_name), 1),
                      _cache[15] || (_cache[15] = _createElementVNode("th", { class: "as-center a" }, "Trung bình", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[16] || (_cache[16] = _createElementVNode("td", null, "FH Average", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'corners_fh_avg_overall'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'corners_fh_avg_overall')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'corners_fh_avg_overall'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'corners_fh_avg_overall')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'corners_fh_avg_overall'), getValueWithMode('away', 'corners_fh_avg_overall')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'corners_fh_avg_overall'), getValueWithMode('away', 'corners_fh_avg_overall'))), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[17] || (_cache[17] = _createElementVNode("td", null, "FH Over 4", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'corners_fh_over4_percentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'corners_fh_over4_percentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'corners_fh_over4_percentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'corners_fh_over4_percentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'corners_fh_over4_percentage_overall'), getValueWithMode('away', 'corners_fh_over4_percentage_overall')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'corners_fh_over4_percentage_overall'), getValueWithMode('away', 'corners_fh_over4_percentage_overall'))) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[18] || (_cache[18] = _createElementVNode("td", null, "FH Over 5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'corners_fh_over5_percentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'corners_fh_over5_percentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'corners_fh_over5_percentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'corners_fh_over5_percentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'corners_fh_over5_percentage_overall'), getValueWithMode('away', 'corners_fh_over5_percentage_overall')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'corners_fh_over5_percentage_overall'), getValueWithMode('away', 'corners_fh_over5_percentage_overall'))) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[19] || (_cache[19] = _createElementVNode("td", null, "FH Over 6", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'corners_fh_over6_percentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'corners_fh_over6_percentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'corners_fh_over6_percentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'corners_fh_over6_percentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'corners_fh_over6_percentage_overall'), getValueWithMode('away', 'corners_fh_over6_percentage_overall')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'corners_fh_over6_percentage_overall'), getValueWithMode('away', 'corners_fh_over6_percentage_overall'))) + "% ", 3)
                    ])
                  ])
                ]),
                _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("table", _hoisted_15, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[20] || (_cache[20] = _createElementVNode("th", null, "Second Half", -1)),
                      _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.footyStats?.home_name), 1),
                      _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.footyStats?.away_name), 1),
                      _cache[21] || (_cache[21] = _createElementVNode("th", { class: "as-center a" }, "Trung bình", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[22] || (_cache[22] = _createElementVNode("td", null, "2H Average", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'corners_2h_avg_overall'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'corners_2h_avg_overall')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'corners_2h_avg_overall'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'corners_2h_avg_overall')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'corners_2h_avg_overall'), getValueWithMode('away', 'corners_2h_avg_overall')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'corners_2h_avg_overall'), getValueWithMode('away', 'corners_2h_avg_overall'))), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[23] || (_cache[23] = _createElementVNode("td", null, "FH Over 4", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'corners_2h_over4_percentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'corners_2h_over4_percentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'corners_2h_over4_percentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'corners_2h_over4_percentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'corners_2h_over4_percentage_overall'), getValueWithMode('away', 'corners_2h_over4_percentage_overall')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'corners_2h_over4_percentage_overall'), getValueWithMode('away', 'corners_2h_over4_percentage_overall'))) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[24] || (_cache[24] = _createElementVNode("td", null, "FH Over 5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'corners_2h_over5_percentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'corners_2h_over5_percentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'corners_2h_over5_percentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'corners_2h_over5_percentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'corners_2h_over5_percentage_overall'), getValueWithMode('away', 'corners_2h_over5_percentage_overall')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'corners_2h_over5_percentage_overall'), getValueWithMode('away', 'corners_2h_over5_percentage_overall'))) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[25] || (_cache[25] = _createElementVNode("td", null, "FH Over 6", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'corners_2h_over6_percentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'corners_2h_over6_percentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'corners_2h_over6_percentage_overall'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'corners_2h_over6_percentage_overall')) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'corners_2h_over6_percentage_overall'), getValueWithMode('away', 'corners_2h_over6_percentage_overall')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'corners_2h_over6_percentage_overall'), getValueWithMode('away', 'corners_2h_over6_percentage_overall'))) + "% ", 3)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})